var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.652,
    height: 16.652,
    viewBox: "0 0 16.652 16.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14100",
    "data-name": "Group 14100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14099",
    "data-name": "Group 14099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11207",
    "data-name": "Path 11207",
    d: "M8.326,0a8.326,8.326,0,1,0,8.326,8.326A8.321,8.321,0,0,0,8.326,0Zm0,15.351a7.025,7.025,0,1,1,7.025-7.025A7.021,7.021,0,0,1,8.326,15.351Z",
    fill: "currenColor"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14102",
    "data-name": "Group 14102",
    transform: "translate(7.676 6.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14101",
    "data-name": "Group 14101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11208",
    "data-name": "Path 11208",
    d: "M236.65,214.33a.65.65,0,0,0-.65.65v4.189a.65.65,0,1,0,1.3,0V214.98A.65.65,0,0,0,236.65,214.33Z",
    transform: "translate(-236 -214.33)",
    fill: "currenColor"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_14104",
    "data-name": "Group 14104",
    transform: "translate(7.448 4.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14103",
    "data-name": "Group 14103"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 0.878,
    cy: 0.878,
    r: 0.878,
    fill: "currenColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastInfo);
export default __webpack_public_path__ + "static/media/toastInfo.0ce3c59c.svg";
export { ForwardRef as ReactComponent };